export default  [
    {
      path: '/smartPlay/LiveList',
      name: 'liveList',
      hidden: true,
      component: () => import('@/views/smartPlay/LiveList'),
      meta: { title: 'menu.liveList', keepAlive: true, permission: ['table'] },
    },
    {
      path: '/smartPlay/CreateLive',
      name: 'createLive',
      hidden: true,
      component: () => import('@/views/smartPlay/CreateLive'),
      meta: { title: 'menu.createLive', keepAlive: true, permission: ['form'] },
    },
  ]